'use client';
import styles from './maiacard.module.scss';
import React, { useEffect } from 'react';
import { Text } from '@/ui-components/atoms/Text/Text';
import { Button } from '@/ui-components/atoms/Button/Button';
import { SinglePlanCardProps } from '@/ui-components/molecules/SinglePlanCard/SinglePlanCard.types';
import { SinglePlanCard } from '@/ui-components/molecules/SinglePlanCard/SinglePlanCard';
import { GridProps } from '@/ui-components/atoms/Layout/Grid/interfaces';
import { Grid } from '@/ui-components/atoms/Layout/Grid/Grid';
import cn from 'classnames';
import { YMM_DATA_EVENT } from '@/src/hooks/useYmmDomData';
export interface MaiaCardProps {
    maiaCards?: SinglePlanCardProps[];
    flowType?: string;
    flowName?: string;
    student: string;
    tokenType: string;
    fixedCardHeight?: boolean;
    isTenColumnLayout?: boolean;
}
export function MaiaCard({
    maiaCards,
    flowType,
    flowName,
    student,
    tokenType,
    fixedCardHeight,
    isTenColumnLayout = true,
}: MaiaCardProps): React.JSX.Element {
    useEffect(() => {
        if (student && tokenType) {
            window.dispatchEvent(new CustomEvent(YMM_DATA_EVENT, { detail: { student, tokenType } }));
        }
    }, [student, tokenType]);
    const cards = maiaCards ?? [];
    const isSingle = cards.length === 1;
    const singleCard = isSingle ? cards[0] : undefined;
    const hasAnyFlag = fixedCardHeight && cards.some((card) => !card.hideBanner);
    const multiCardGrid = (
        <Grid container className={cn(styles.multiCardGrid, { [styles.fixedCardHeight]: fixedCardHeight })}>
            {cards.map((card, i) => {
                const cardHasFlag = !card.hideBanner;
                const colSpan: GridProps['col'] =
                    cards.length === 2 ? { sm: 12, md: 6, lg: 6 } : { sm: 12, md: 6, lg: 4 };
                return (
                    <Grid key={i} col={colSpan}>
                        <SinglePlanCard
                            {...card}
                            index={i}
                            className={cn(card.className, {
                                [styles.flagOffset]: hasAnyFlag && !cardHasFlag,
                            })}
                        />
                    </Grid>
                );
            })}
        </Grid>
    );
    return (
        <div
            className={cn(styles.maiaCardWrapper, {
                [styles.multiCard]: !isSingle,
                [styles.fixedCardHeight]: fixedCardHeight,
            })}
            data-student={student}
            data-tokentype={tokenType}
            {...(flowType ? { 'data-flowtype': flowType } : {})}
            {...(flowName ? { 'data-flowname': flowName } : {})}
        >
            {isSingle ? (
                singleCard && <SinglePlanCard {...singleCard} hideCta isSingleCard />
            ) : isTenColumnLayout ? (
                <Grid container>
                    <Grid col={{ lg: 10 }} start={{ lg: 2 }}>
                        {multiCardGrid}
                    </Grid>
                </Grid>
            ) : (
                multiCardGrid
            )}
            {isSingle && (singleCard?.cta || singleCard?.ctaLegal) && (
                <div className={styles.externalCta}>
                    {singleCard?.ctaLegalPosition === 'above' && singleCard?.ctaLegal && (
                        <Text tag="p" className={styles.ctaLegal}>
                            {singleCard.ctaLegal}
                        </Text>
                    )}
                    {singleCard?.cta && <Button {...singleCard.cta} type="button" fitting="fill-container" />}
                    {singleCard?.ctaLegalPosition !== 'above' && singleCard?.ctaLegal && (
                        <Text tag="p" className={styles.ctaLegal}>
                            {singleCard.ctaLegal}
                        </Text>
                    )}
                </div>
            )}
        </div>
    );
}
